<div class="energy-monitor-list-container">
  @for (groupId of groups; track groupId) {
    <div class="energy-monitor-container">
      <lds-energy-monitor-card [data]="user.energyMonitors[groupId]"></lds-energy-monitor-card>
    </div>
  }
</div>